import { createAction } from 'redux-actions';
import WixSDK from 'shared/utils/wix-sdk';
import { getCompId } from 'shared/utils/comp-id';
import { updateCSS } from 'shared/utils/update-css';
import { hydratedData } from 'services/hydrated-data';

export const APP_SETTINGS_UPDATE = 'CLIENT.APP_SETTINGS.SET';

export const updateAppSettings = createAction(APP_SETTINGS_UPDATE);

function getStyleParams() {
  const preloadedStyleParams = hydratedData.getStyleParams();

  if (preloadedStyleParams) {
    return Promise.resolve(preloadedStyleParams);
  }

  return WixSDK.Styles.getStyleParams();
}

export const fetchAppSettings = () => dispatch =>
  Promise.all([WixSDK.Settings.getSiteInfo(), getStyleParams()]).then(
    ([{ url }, styles]) => {
      updateCSS(styles);

      dispatch(
        updateAppSettings({
          ...styles,
          compId: getCompId(),
          instance: WixSDK.Utils.getInstance(),
          instanceId: WixSDK.Utils.getInstanceId(),
          editMode: WixSDK.Utils.getViewMode(),
          siteUrl: url,
        }),
      );

      return styles;
    },
  );
